import { render, staticRenderFns } from "./GalleryEmptyDefaultLayout.vue?vue&type=template&id=930012aa&scoped=true&"
import script from "./GalleryEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./GalleryEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930012aa",
  null
  
)

export default component.exports